<template>
  <div class="lists-wrapper__lists">
    <div class="grid-wrapper">
      <div class="col col-12">
        <div class="grid-info">
          <span class="grid-heading">
            <h1>{{ $t('Addresses') }}</h1>
            <span class="entries">{{ NumberFormat(entries) }} {{ $t(`entr${entries == 1 ? 'y' : 'ies'}`) }}</span>
          </span>
          <!-- <div class="grid-search">
            <input type="text" @keyup.enter="Search" v-model="search.query" :placeholder="$t('Search')" spellcheck="false">
          </div> -->
        </div>
        <table class="table odd-even">
          <tbody>
            <tr :data-id="item.id" class="address-list__row clickable" @mousedown="RowClick" @mousemove="RowClick" @mouseup="RowClick" :key="item.id" v-for="item in addresses">
              <td class="name">{{ item.name }}</td>
              <td class="address">{{ item.address }}</td>
              <td class="zipcode">{{ item.zipcode }}</td>
              <td class="city">{{ item.city }}</td>
              <td class="country">
                <div class="country">
                  <Flag :code="item.country.code" size="small" />
                  <div class="country" style="margin-left: 10px;">{{ CountryName(item.country.code) }}</div>
                </div>
              </td>
              <!-- <td @mouseenter="SetBackground" @mouseleave="SetBackground" class="actions">
                <a @click.prevent="" href="" class="icon dots">
                  <ul class="item-actions">
                    <li><a @click.prevent="" href="">{{ $t('Print label') }}</a></li>
                  </ul>
                </a>
              </td> -->
            </tr>
          </tbody>
          <thead>
            <tr class="list__actions">
              <th class="name">{{ $t('Name') }}</th>
              <th class="address">{{ $t('Street') }}</th>
              <th class="zipcode">{{ $t('Postal code') }}</th>
              <th class="city">{{ $t('City') }}</th>
              <th class="country">{{ $t('Country') }}</th>
              <!-- <th class="edit"></th> -->
            </tr>
          </thead>
        </table>
      </div>
    </div>

    <transition name="fade">
      <div @mousedown="PopupMouseEvent" @mouseup="PopupMouseEvent" class="validate-popup" v-if="popup.show">
        <div class="validate-popup__content">
          <form id="popup-form" @submit.prevent>
            <button type="submit" hidden />
            <div class="titles">
              <p class="title">Are you sure?</p>
              <p class="subtitle" v-html="popup.message" />
            </div>
            <div style="width: 750px; margin-bottom: 50px;">
              <div class="flex-group flex-column">
                <div class="flex-group">
                  <div class="flex-row">
                    <div class="flex-column">
                      <div class="label required">
                        <span class="label-text">{{ $t('Label printer') }} </span>
                        <div class="v-select-wrapper">
                          <v-select :class="{'vs--loading': printer.loading}" v-model="printer.selected" :options="printer.options" :clearable="false">
                            <template slot="spinner">
                              <div class="vs__spinner" v-show="printer.loading" />
                            </template>
                            <template #search="{attributes, events}">
                              <input class="vs__search" v-bind="attributes" v-on="events" :required="!printer.selected.id">
                            </template>
                            <template v-slot:selected-option="option">
                              <div class="truncate" :title="printer.selected.title">
                                <span :class="['state', option.color]">{{ option.label }}</span>
                              </div>
                            </template>
                            <template slot="option" slot-scope="option">
                              <div class="truncate" :title="option.title">
                                <span :class="['state', option.color]">{{ option.label }}</span>
                              </div>
                            </template>
                          </v-select>
                          <!-- <a class="button" @click.prevent="RefreshPrinterOptions" href="">Refresh</a> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="actions">
              <a class="btn-stateless cancel" @click.prevent="$event.preventDefault(), popup.button.cancel.click()" href="">{{ popup.button.cancel.text }}</a>
              <a class="btn-success confirm" @click.prevent="popup.button.confirm.click" href="">{{ popup.button.confirm.text + popup.action + ' it' }}</a>
            </div>
          </form>
        </div>
      </div>
    </transition>

    <div class="loading" v-if="loading">
      <div class="loading-element">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

  </div>
</template>

<script>
  import { TableElementsBehaviour } from '@/mixins/TableElementsBehaviour';
  import { Config }     from '@/helpers/Config';
  import { Tool }       from '@/helpers/Tool';
  import { BPA }        from '@/helpers/BPA';
  //import Modal          from '@/components/snippets/Modal';
  import Flag           from '@/components/snippets/Flag';

  export default {
    name: 'QuickLabelAddressList',
    mixins: [
      TableElementsBehaviour, 
      Config, 
      Tool, 
      BPA
    ],
    components: {
      //Modal,
      Flag
    },
    data() {
      return {
        loading: false,
        clickables: [],
        cached: {},
        address: {},
        countries: [],
        addresses: [],
        entries: 0,
        company: {
          data: {},
          address: {}
        },
        printer: {
          loading: false,
          selected: null,
          options: []
        },
        popup: {
          show: false,
          mousedown: null,
          message: '',
          action: '',
          button: {
            cancel: {
              click() {},
              text: 'No'
            },
            confirm: {
              click() {},
              text: 'Yes, '
            }
          }
        },
        permission: {
          admin: ['admin', 'quick_label_generator_admin'],
          user: ['quick_label_generator']
        },
      };
    },
    created() {},
    async mounted() {
      this.loading = true;
      this.company.data = await BPA.api.GetCompanyData().then(response => {
        return BPA.api.response({response, return: 'json'});
      }).then(response => {
        if (!response.ok || !response.result) return {};
        return response.result;
      }).catch(() => ({}));
      let printer_selected = BPA.printer.fetch('label');
      this.printer.selected = printer_selected ? Tool.PrinterOptions([printer_selected])[0] : '';
      if (this.Check(this.permission.admin)) {
          this.printer.options = await this.GetPrinterOptions();
      }
      this.countries = (await BPA.api.Countries('GET')).map(country => ({
        id: country.id, label: country.name, code: country.iso_code_2
      }));
      await this.QueryAddresses();
      this.loading = false;
    },
    destroyed() {},
    computed: {
      main() {
        const main = {
          company: BPA.util.GetCompany(),
          view: document.querySelector('.content-scroll')
        }
        main.view.scroll = {top: 0};
        return main;
      },
      locale() {
        return this.$i18n.locale;
      }
    },
    watch: {
      locale() {
        //this.state = this.$t(this.Capitalize(this.search.state));
      }
    },
    methods: {
      Hyperlink(props = {}) {
        return Tool.Hyperlink(props);
      },
      DateFormat(date) {
        return Tool.DateFormat(date);
      },
      NumberFormat(number) {
        return Tool.NumberFormat(number);
      },
      Empty(element) {
        while (element.firstChild) {
          element.removeChild(element.firstChild);
        }
      },
      CountryName(country_code) {
        return Tool.CountryName(country_code);
      },
      Alphabetize(list, prop) {
        return Tool.Alphabetize(list, prop);
      },
      CloneObject(object = {}) {
        return JSON.parse(JSON.stringify(object));
      },
      Check(required) {
        return BPA.permissions(required).length;
      },
      async GetPrinterOptions() {
        return await new Promise((resolve, reject) => {
          BPA.api.GetPrinterList().then(response => {
            return BPA.api.response({response, return: 'json'});
          }).then(response => {
            if (!response.ok) return reject();
            resolve(Tool.PrinterOptions(response.result, 'label'));
          }).catch(reject);
        }).catch(e => e);
      },
      async RefreshPrinterOptions() {
        return await new Promise(async resolve => {
          this.printer.options = await this.GetPrinterOptions();
          if (this.printer.selected.id) {
            if (!this.printer.options.some(option => option.id == this.printer.selected.id)) {
              this.printer.selected = '';
            }
          }
          resolve(this.printer.options);
        });
      },
      async GetAddressBook() {
        return await new Promise((resolve, reject) => {
          BPA.api.GetAddressBook().then(response => {
            return BPA.api.response({response, return: 'json'});
          }).then(response => {
            this.loading = false;
            if (!response.ok || !response.result) return reject();
            resolve(response.result);
          }).catch(reject);
        }).catch(e => e);
      },
      async QueryAddresses() {
        return await new Promise(async (resolve, reject) => {
          let addresses = await this.GetAddressBook();
          if (!addresses) reject();
          for (let address of addresses) {
            address.name = String(address.first_name + ' ' + address.last_name).trim();
            let country = this.countries.find(country => country.id == address.res_country_id) || {};
            address.country = {code: country.code, name: country.label};
          }
          this.company.address = addresses.find(address => address.address.includes(this.company.data.invoicing_abroad.sender.address)) || {};
          addresses = addresses.filter(address => address.id != this.company.address.id && new RegExp(`^${this.company}`, 'i').test(address.name));
          this.Alphabetize(addresses, 'name');
          this.addresses = addresses;
          this.entries = addresses.length;
          //BPA.cache.local({name: this.$options.name, set: {addresses}});
          this.$nextTick().then(() => {
            this.clickables = document.querySelectorAll('.clickable');
            if (this.cached.address && Object.keys(this.cached.address).length) {
              this.EditAddress(this.cached.address);
            }
          });
          resolve(addresses);
        });
      },
      RowClick(e) {
        if (!e) return;
        let row = {};
        let elm = e.target;
        if (elm.localName != 'tr') row = elm.closest('tr');
        const filter = ['actions', 'icon dots'];
        const mousedown = (state) => {
          if (state === true || state === false) {
            row.mousedown = state;
          } else {
            return row.mousedown;
          }
        };
        for (let i = 0; i < this.clickables.length; i++) {
          if (this.clickables[i] != row) {
            this.clickables[i].classList.remove('hover', 'selected');
          }
        }
        if (elm.localName == 'a') return;
        if (filter.some((x) => new RegExp(x).test(elm.className))) return;
        if (e.type == 'mousedown') {
          mousedown(e.which == 1);
        }
        if (e.type == 'mousemove') {
          mousedown(false);
        }
        if (e.type == 'mouseup') {
          if (mousedown()) {
            let address = this.addresses.find(item => item.id == row.dataset.id) || {};
            this.PrintQuickLabel(address);
            row.classList.remove('hover');
            row.classList.add('selected');
          }
          mousedown(false);
        }
      },
      async CreateCustomLabel(request = {}) {
        return await new Promise((resolve, reject) => {
          if (!Object.keys(request).length) return reject();
          this.loading = true;
          BPA.api.CreateCustomLabel(request).then(response => {
            return BPA.api.response({response, 
              return: () => {
                resolve(response);
                this.$eventHub.$emit('ShowMessages', {
                  message: 'Label successfully created',
                  type: 'success',
                  hide: 2000
                });
                return response.arrayBuffer();
              },
              error: (message) => {
                reject(message);
                message = {text: message || ''};
                message.parts = message.text.split(' - ');
                if (message.parts.length == 2) {
                  if (request.agent_code == 'dhl') {
                    message = message.text;
                  }
                  if (request.agent_code == 'pdk') {
                    message.external = {
                      code: message.parts[1].match(/\[\d+\]/), 
                      errors: message.parts[1].match(/\[\D+\]/), 
                      message: []
                    };
                    if (message.external.errors) {
                      for (let error of JSON.parse(message.external.errors)) {
                        message.external.message.push({
                          field: error.messageCode || error.field,
                          message: error.message
                        });
                      }
                    }
                    message.external.message = JSON.stringify(message.external.message) || '';
                    message = `${message.parts[0]} - ${message.external.code || ''} ${message.external.message}`;
                  }
                }
                this.$eventHub.$emit('ShowMessages', {
                  message: message,
                  type: 'error',
                  close: true
                });
              }
            }).then(response => {
              this.loading = false;
              if (!response.ok || !response.result) return reject();
            });
          }).catch(reject);
        }).catch(e => e);
      },
      async PrintQuickLabel(address = {}) {
        if (!address) return;
        const company = (this.CloneObject(this.company) || {})?.address || {};
        const request = {
          agent_code: 'gls',
          shipping_method: 'business',
          operation_code: 'print',
          body: {
            printer_id: this.printer.selected.id,
            ref: '{{Auto}}',
            title: '[SHIPPING LABEL] Gls Business',
            args: {
              company: address.name,
              ref: '',
              name: address.first_name,
              lastname: address.last_name,
              email: address.email,
              tlf: address.phone,
              address: address.address,
              zipcode: address.zipcode,
              city: address.city,
              country_num: address.res_country_id,
              shipment_date: null,
              weight: 249,
              sender_name: company.name,
              sender_address: company.address,
              sender_phone_number: company.phone,
              sender_email: company.email,
              sender_res_country_id: company.res_country_id,
              sender_zip_code: company.zipcode,
              send_city: company.city
            }
          }
        }
        if (this.Check(this.permission.admin)) {
          await this.RefreshPrinterOptions();
          const confirmed = await new Promise(resolve => {
            this.popup.action = 'print';
            this.popup.show = true;
            let selected_printer = this.printer.selected;
            this.popup.button.cancel.click = (event) => {
              this.printer.selected = selected_printer;
              if (event) event.preventDefault();
              resolve(false);
              return false;
            }
            this.popup.button.confirm.click = () => {
              request.body.printer_id = this.printer.selected.id;
              this.popup.show = false;
              resolve(true);
            }
          });
          if (!confirmed) return;
          this.CreateCustomLabel(request);
        } else if (this.Check(this.permission.user)) {
          if (!this.printer.selected.id) {
            return this.$eventHub.$emit('ShowMessages', {
              message: 'No label printer configured. Please contact your administrator.',
              type: 'error',
              close: true
            });
          }
          this.$eventHub.$emit('ValidateModalStart', {
            approve: 'Yes, print it',
            disapprove: 'No',
            message: `Prints out a shipping label on your label printer.`,
            type: 'success'
          });
          this.$eventHub.$on('ValidateModalStop', async (approve) => {
            this.$eventHub.$off('ValidateModalStop');
            if (!approve) return;
            this.CreateCustomLabel(request);
          });
        }
      },
      PopupMouseEvent(e) {
        const event = e.type;
        const clicked = e.target;
        if (event == 'mousedown') {
          return this.popup.mousedown = clicked;
        }
        const mousedown = this.popup.mousedown;
        const popup = document.querySelector('.validate-popup');
        const cancel = popup.querySelector('a.cancel');
        if ([popup, cancel].includes(clicked) && clicked == mousedown) {
          if (this.popup.button.cancel.click) {
            this.popup.button.cancel.click();
          }
          this.popup.show = false;
          this.$eventHub.$off('ValidateModalStop');
        }
        this.popup.mousedown = null;
      },
      PopupConfirm() {
        this.$eventHub.$emit('ValidateModalStop', true);
        this.popup.show = false;
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>